
import React from 'react';
import { Monitor, ExternalLink, Github } from 'lucide-react';
import { PROJECTS } from '../constants';

const Projects: React.FC<{ darkMode: boolean }> = ({ darkMode }) => {
   const playHoverSound = () => {
    try {
      // Short, subtle UI 'pop' sound
      const audio = new Audio('https://res.cloudinary.com/dgddwbftd/video/upload/v1770277121/lucadialessandro-arcade-fx-288597_iagpvb.mp3');
      audio.volume = 0.2;
      audio.play().catch(e => console.debug("Audio play blocked until interaction"));
    } catch (error) {
      console.error("Error playing sound:", error);
    }
  };
  return (
    <div className="py-10">
      <div className="flex items-center gap-3 mb-12">
        <Monitor className="text-blue-600" />
        <h3 className={`text-3xl font-bold ${darkMode ? 'text-white' : 'text-slate-900'}`}>Featured Projects</h3>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-10">
        {PROJECTS.map((project, idx) => (
          <div key={idx}  onMouseEnter={playHoverSound} className={`group flex flex-col ${darkMode ? 'bg-slate-900' : 'bg-white'} rounded-3xl overflow-hidden border border-slate-200 dark:border-slate-800 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl`}>
            <div className="relative h-56 overflow-hidden">
              <img 
                src={project.image} 
                alt={project.title} 
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-between p-6">
                <div className="flex gap-4">
                  <a href={project.link} className="p-2 bg-white rounded-full text-slate-900 hover:scale-110 transition-transform">
                    <ExternalLink size={20} />
                  </a>
                </div>
              </div>
            </div>
            
            <div className="p-8 flex-1 flex flex-col">
              <h4 className={`text-2xl font-bold mb-3 ${darkMode ? 'text-white' : 'text-slate-900'}`}>{project.title}</h4>
              <p className={`text-slate-600 ${darkMode ? 'dark:text-slate-400' : ''} mb-6 flex-1`}>{project.description}</p>
              
              <div className="flex flex-wrap gap-2 mt-auto">
                {project.tech.map((t, i) => (
                  <span key={i} className="text-[10px] uppercase tracking-wider font-bold text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/20 px-2 py-1 rounded">
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;
